import { Card, CardContent } from "@shared/ui/card";
import { AlertTriangle, ArrowRight } from "lucide-react";

type TenantAccountCardProps = {
  owner: {
    name: string;
    number: string;
    phone: string;
    address: string;
  };
};


export const TenantAccountCard = ({
  owner,
}: TenantAccountCardProps) => {

  const ownerDetails = [
    { key: "name", label: "OWNER NAME" },
    { key: "number", label: "OWNER ACCOUNT" },
    { key: "phone", label: "OWNER PHONE" },
    { key: "address", label: "OWNER ADDRESS" },
  ] as const;

  return (
    <Card className="rounded-xl border-2 border-orange-200 bg-orange-50/60 overflow-hidden shadow-sm">
      <CardContent className="p-0">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="bg-orange-400 p-2.5 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-bold text-orange-900">
                This is a Tenant Account
              </p>
              <p className="text-sm text-orange-700">
                Currently linked under owner account {owner.number}
              </p>
            </div>
          </div>

          <span className="text-xs font-bold tracking-wider text-white bg-orange-400 px-4 py-1.5 rounded-full">
            TENANT
          </span>
        </div>

        {/* Body */}
        <div className="px-5 pb-5 space-y-4">
          {/* Banner */}
          <div className="rounded-md px-4 py-3 text-sm bg-orange-100/70 text-orange-900 border-l-4 border-orange-400">
            {"This account is registered as a tenant under a property owner. The transfer has been initiated to move ownership to a new tenant at the same premises."}
          </div>

          {/* Owner Details — single horizontal row on lg, responsive below */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4 text-sm">
            {ownerDetails.map(({ key, label }) => (
              <div key={key}>
                <p className="text-gray-500 text-xs font-semibold tracking-wider">
                  {label}
                </p>
                <p className="font-bold text-gray-900 mt-1">{owner[key]}</p>
              </div>
            ))}
          </div>

          {/* Transfer Decision — read-only chip, only when not yet transferred */}
          <div className="flex flex-wrap items-center gap-3 pt-1">
            <p className="font-bold text-orange-900">Transfer Decision:</p>
            <span className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-700 font-semibold text-sm px-3 py-1.5 rounded-full">
              <ArrowRight className="w-4 h-4" />
              {'Transfer to Owner'}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};